module.exports = __webpack_public_path__ + "img/app.51b2db38.png";